module.exports = __webpack_public_path__ + "Flaticon.ebb8492ee48097590c4d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/header/Flaticon.svg
// module id = ../../../../../src/assets/fonts/header/Flaticon.svg
// module chunks = 6